import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { Tab as SemanticUiTab } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { ChildrenPropType } from '../../../../../../services/proptypes';
import { classNames } from '../../../../../../utils/classname';
import './Content.css';
var defaultProps = {
  className: '',
  children: null
};
export default function Content(_ref) {
  var active = _ref.active,
    children = _ref.children,
    className = _ref.className;
  if (_isEmpty(children)) {
    return null;
  }
  var finalClassName = classNames(_defineProperty({
    content: true
  }, className, true));
  return /*#__PURE__*/React.createElement(SemanticUiTab.Pane, {
    className: finalClassName,
    active: active
  }, children);
}
Content.defaultProps = defaultProps;